module.exports = __webpack_public_path__ + "img/NewVanIcon.bd4edefe.svg";